//** buying-role Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getBuyingRole = createAsyncThunk('buyingRoleSlice/getBuyingRole', async (_,{dispatch}) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/buying-role', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getBuyingRoleOption = createAsyncThunk('buyingRoleSlice/getBuyingRoleOption', async () => {
    try {
        let response = await axios.get('/buying-role/options', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createBuyingRole = createAsyncThunk('buyingRoleSlice/createBuyingRole', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/buying-role', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Buying Role added successfully.');
        dispatch(getBuyingRole());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateBuyingRole = createAsyncThunk('buyingRoleSlice/updateBuyingRole', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/buying-role/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Buying Role updated successfully.');
        await dispatch(getBuyingRole());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateBuyingRoleStatus = createAsyncThunk('buyingRoleSlice/updateBuyingRoleStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/buying-role/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully !');
        dispatch(getBuyingRole());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const updateBuyingRoleLevel = createAsyncThunk('leadSourceSlice/updateBuyingRoleLevel', async (data) => {
    try {
        let response = await axios.put('/buying-role/update/level', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Buying Role Level updated successfully !');
        dispatch(getBuyingRole());
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteBuyingRole = createAsyncThunk('buyingRoleSlice/deleteBuyingRole', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/buying-role/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Buying Role deleted successfully.');
        await dispatch(getBuyingRole());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const buyingRoleSlice = createSlice({
    name: 'buyingRoleSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBuyingRole.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getBuyingRoleOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default buyingRoleSlice.reducer;
